import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

let orgId = localStorage.getItem("sapientia_org") || null;

export function setOrgId(id) {
  orgId = id;
  if (id) localStorage.setItem("sapientia_org", id);
  else localStorage.removeItem("sapientia_org");
}

export function getOrgId() {
  return orgId;
}

api.interceptors.request.use((cfg) => {
  if (orgId) cfg.headers["X-Organization-Id"] = orgId;
  return cfg;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Ocorreu um erro. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
